import { FetchEventRequest, FetchEventResponse, FETCH_EVENT, toFuncName } from '@atomica.co/irori';
import { convert, RequestType } from '@atomica.co/utils';
import { functions } from '../firebase';

export default class EventRequest {
  public static fetchEvent = async (request: FetchEventRequest): Promise<FetchEventResponse> => {
    return await new Promise((resolve, reject) => {
      const func = functions.httpsCallable(toFuncName(FETCH_EVENT));

      func(request)
        .then(res => resolve(convert(RequestType.RECEIVER, res.data)))
        .catch(error => reject(error));
    });
  };
}
